export default function initDesktopMenu() {

    // ==========================================
    // 1. LÓGICA DOS DROPDOWNS (Idiomas e Secundário)
    // ==========================================
    const langDropdown = document.querySelector('.js-lang-dropdown');
    const secondaryDropdown = document.querySelector('.js-secondary-dropdown');

    // Função genérica para fechar todos os dropdowns ativos
    function closeAllDropdowns() {
        if (langDropdown) langDropdown.classList.remove('is-active');
        if (secondaryDropdown) secondaryDropdown.classList.remove('is-active');

        // Reset de ARIA labels
        document.querySelectorAll('.c-lang-dropdown__toggle, .js-toggle-secondary').forEach(el => {
            el.setAttribute('aria-expanded', 'false');
        });
    }

    // Listener Idioma (Funciona Mobile e Desk)
    if (langDropdown) {
        const langToggle = langDropdown.querySelector('.c-lang-dropdown__toggle');
        if (langToggle) {
            langToggle.addEventListener('click', (e) => {
                e.preventDefault(); // Previne qualquer comportamento padrão do botão
                e.stopPropagation(); // Impede que o clique feche imediatamente

                const wasActive = langDropdown.classList.contains('is-active');
                closeAllDropdowns(); // Fecha outros

                if (!wasActive) {
                    langDropdown.classList.add('is-active');
                    langToggle.setAttribute('aria-expanded', 'true');
                }
            });
        }
    }

    // Listener Menu Secundário (Apenas Desk)
    if (secondaryDropdown) {
        const secondaryToggle = secondaryDropdown.querySelector('.js-toggle-secondary');
        if (secondaryToggle) {
            secondaryToggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const wasActive = secondaryDropdown.classList.contains('is-active');
                closeAllDropdowns();

                if (!wasActive) {
                    secondaryDropdown.classList.add('is-active');
                    secondaryToggle.setAttribute('aria-expanded', 'true');
                }
            });
        }
    }

    // Fechar dropdowns ao clicar fora ou apertar ESC
    document.addEventListener('click', closeAllDropdowns);
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeAllDropdowns();
    });


    // ==========================================
    // 2. LÓGICA DO MEGA MENU (Hover de Produtos)
    // ==========================================
    const megamenuTriggers = document.querySelectorAll('.js-megamenu-trigger');

    if (megamenuTriggers.length > 0) {
        megamenuTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', function () {

                // 1. Isola o contexto (Qual painel estamos mexendo? Produtos ou Marcas?)
                const currentPanel = this.closest('.c-menu-panel');
                if (!currentPanel) return;

                // 2. Busca os elementos ALVO *apenas dentro do painel atual*!
                // ISSO RESOLVE O SEU BUG: Cada painel terá suas próprias referências.
                const localTriggers = currentPanel.querySelectorAll('.js-megamenu-trigger');
                const localTargets = currentPanel.querySelectorAll('.js-megamenu-target');
                const localImg = currentPanel.querySelector('.js-megamenu-img');
                const localMainLink = currentPanel.querySelector('.js-megamenu-main-link');

                // Elementos exclusivos das marcas (só vão existir no painel de marcas)
                const localGradient = currentPanel.querySelector('.js-megamenu-gradient');
                const localLogo = currentPanel.querySelector('.js-megamenu-logo');

                // 3. Atualiza os estados ativos
                localTriggers.forEach(t => t.classList.remove('is-active'));
                localTargets.forEach(t => t.classList.remove('is-active'));
                this.classList.add('is-active');

                // 4. Mostra a sublista correta (Se existir)
                const targetId = this.getAttribute('data-target');
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) targetElement.classList.add('is-active');
                }

                // 5. Atualiza URL do botão
                const targetUrl = this.getAttribute('data-url');
                if (targetUrl && localMainLink) {
                    localMainLink.href = targetUrl;
                }

                // 6. Efeitos Visuais Dinâmicos (Imagem, Cor, Logo)
                const newImage = this.getAttribute('data-image');
                const newColor = this.getAttribute('data-color');
                const newLogo = this.getAttribute('data-logo');

                // Esconde e troca suavemente (Efeito Fade)
                if (localImg || localGradient || localLogo) {
                    if (localImg) localImg.style.opacity = '0';
                    if (localLogo) localLogo.style.opacity = '0';

                    setTimeout(() => {
                        // Troca Imagem
                        if (newImage && localImg) {
                            localImg.src = newImage;
                            localImg.style.opacity = '1';
                        }

                        // Troca Cor do Degradê
                        if (newColor && localGradient) {
                            localGradient.style.setProperty('--brand-color', newColor);
                        }

                        // Troca Logo
                        if (newLogo && localLogo) {
                            localLogo.src = newLogo;
                            localLogo.style.opacity = '1';
                        } else if (localLogo) {
                            // Se a marca não tiver logo, a gente esconde
                            localLogo.src = '';
                            localLogo.style.opacity = '0';
                        }

                    }, 150);
                }
            });
        });
    }

    // ==========================================
    // LÓGICA DO HOVER INTENT (Safe Triangle) - Menu Principal
    // ==========================================
    const navItems = document.querySelectorAll('.c-nav__item');
    let hoverTimeout; // Variável para guardar o timer
    const delay = 150; // Tempo de tolerância em milissegundos (Ajuste se precisar, 150 a 250 é o padrão ouro)

    navItems.forEach(item => {
        // Quando o mouse ENTRA no item (seja no link ou no próprio painel aberto)
        item.addEventListener('mouseenter', () => {
            // Cancela qualquer timer de fechamento que estivesse rodando
            clearTimeout(hoverTimeout);

            // Fecha outros menus que possam estar abertos (evita menus sobrepostos)
            navItems.forEach(sibling => {
                if (sibling !== item) {
                    sibling.classList.remove('is-hovered');
                }
            });

            // Abre o menu atual
            item.classList.add('is-hovered');
        });

        // Quando o mouse SAI do item
        item.addEventListener('mouseleave', () => {
            // Em vez de fechar na hora, inicia uma contagem
            hoverTimeout = setTimeout(() => {
                item.classList.remove('is-hovered');
            }, delay);
        });
    });


    // ==========================================
    // LÓGICA DO MEGA MENU (Hover INTERNO de Produtos)
    // ==========================================
    if (megamenuTriggers.length > 0) {
        megamenuTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', function () {

                // 1. Isola o contexto (Qual painel estamos mexendo? Produtos ou Marcas?)
                const currentPanel = this.closest('.c-menu-panel');
                if (!currentPanel) return;

                // 2. Busca os elementos ALVO apenas dentro do painel atual!
                const localTriggers = currentPanel.querySelectorAll('.js-megamenu-trigger');
                const localTargets = currentPanel.querySelectorAll('.js-megamenu-target');
                const megamenuImg = currentPanel.querySelector('.js-megamenu-img');
                const megamenuMainLink = currentPanel.querySelector('.js-megamenu-main-link');

                // Elementos exclusivos das marcas
                const megamenuGradient = currentPanel.querySelector('.js-megamenu-gradient');
                const megamenuLogo = currentPanel.querySelector('.js-megamenu-logo');

                // 3. Atualiza os estados ativos
                localTriggers.forEach(t => t.classList.remove('is-active'));
                localTargets.forEach(t => t.classList.remove('is-active'));
                this.classList.add('is-active');

                // 4. Mostra a sublista correta (Se existir)
                const targetId = this.getAttribute('data-target');
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) targetElement.classList.add('is-active');
                }

                // 5. Atualiza URL do botão
                const targetUrl = this.getAttribute('data-url');
                if (targetUrl && megamenuMainLink) {
                    megamenuMainLink.href = targetUrl;
                }

                // 6. Efeitos Visuais Dinâmicos (Imagem, Cor, Logo)
                const newImage = this.getAttribute('data-image');
                const newColor = this.getAttribute('data-color');
                const newLogo = this.getAttribute('data-logo');

                // Esconde e troca suavemente (Efeito Fade)
                if (megamenuImg || megamenuGradient || megamenuLogo) {
                    if (megamenuImg) megamenuImg.style.opacity = '0';
                    if (megamenuLogo) megamenuLogo.style.opacity = '0';

                    setTimeout(() => {
                        // Troca Imagem
                        if (newImage && megamenuImg) {
                            megamenuImg.src = newImage;
                            megamenuImg.style.opacity = '1';
                        }

                        // Troca Cor do Degradê
                        if (newColor && megamenuGradient) {
                            megamenuGradient.style.setProperty('--brand-color', newColor);
                        }

                        // Troca Logo
                        if (newLogo && megamenuLogo) {
                            megamenuLogo.src = newLogo;
                            megamenuLogo.style.opacity = '1';
                        } else if (megamenuLogo) {
                            // Se a marca não tiver logo, a gente esconde
                            megamenuLogo.src = '';
                            megamenuLogo.style.opacity = '0';
                        }

                    }, 150);
                }
            });
        });
    }
}